<Header
  hero_image={props.meta.hero_image}
  nav={props.meta.nav}
  stats={props.meta.stats}
  subtitle={props.meta.subtitle}
  title={props.meta.title}
  title_highlight={props.meta.title_highlight}
/>
<NarrativeIntro
  def_attribution={props.meta.ni_def_attribution}
  def_badge={props.meta.ni_def_badge}
  def_description={props.meta.ni_def_description}
  def_statement_prefix={props.meta.ni_def_statement_prefix}
  def_statement_suffix={props.meta.ni_def_statement_suffix}
  def_title={props.meta.ni_def_title}
  description={props.meta.ni_description}
  description2={props.meta.ni_description2}
  eyebrow_bigpicture={props.meta.ni_eyebrow_bigpicture}
  eyebrow_concepts={props.meta.ni_eyebrow_concepts}
  link1_href={props.meta.ni_link1_href}
  link1_text={props.meta.ni_link1_text}
  link2_href={props.meta.ni_link2_href}
  link2_text={props.meta.ni_link2_text}
  title={props.meta.ni_title}
/>
<Members
  chip_label={props.meta.mb_chip_label}
  data={props.meta.tc_data}
  eyebrow={props.meta.mb_eyebrow}
  legend={props.meta.tc_legend}
  mercosur_members={props.meta.mb_mercosur_members}
  mercosur_prefix={props.meta.mb_mercosur_prefix}
  title={props.meta.mb_title}
/>
<Timeline
  title={props.meta.tl_title}
  description={props.meta.tl_description}
  eyebrow={props.meta.tl_eyebrow}
  milestones={props.meta.tl_milestones}
/>
<TileRow
  eyebrow={props.meta.tr_eyebrow}
  groups={props.meta.tr_groups}
/>
<TradeShareChart
  title={props.meta.tc_title}
  subtitle={props.meta.tc_subtitle}
  legend={props.meta.tc_legend}
  data={props.meta.tc_data}
  source={props.meta.tc_source}
  sourceLabel={props.meta.tc_source_label}
  note={props.meta.tc_note}
  noteLabel={props.meta.tc_note_label}
  link1_href={props.meta.tc_link1_href}
  link1_text={props.meta.tc_link1_text}
  link2_href={props.meta.tc_link2_href}
  link2_text={props.meta.tc_link2_text}
/>
